// extracted by mini-css-extract-plugin
export default {"entityIdeasLink":"IDtz8ucJiZbqi4TGZeJkK"};